import React, {
  createContext,
  forwardRef,
  PropsWithChildren,
  Ref,
  useContext,
  useImperativeHandle,
  useState,
} from 'react';
import { WrappedFormUtils } from '@ant-design/compatible/lib/form/Form';

export type FormItem = {
  form: WrappedFormUtils;
  id: number;
};

type FormListContextType = {
  formList: FormItem[];
  setFormList: React.Dispatch<React.SetStateAction<FormItem[]>>;
};

const FormListContext = createContext<FormListContextType | null>(null);

const FormListContextProviderInner = (
  { children }: PropsWithChildren<Record<string, unknown>>,
  ref: Ref<{ formList: FormItem[] }>,
) => {
  const [formList, setFormList] = useState<FormItem[]>([]);

  useImperativeHandle(ref, () => {
    return {
      formList,
    };
  }, [formList]);

  return <FormListContext.Provider value={{ formList, setFormList }}>{children}</FormListContext.Provider>;
};

export const FormListContextProvider = forwardRef(FormListContextProviderInner) as (
  { children }: PropsWithChildren<Record<string, unknown>>,
  ref: Ref<{ formList: FormItem[] }>,
) => JSX.Element;

export const useFormListContext = () => useContext(FormListContext);
